export default "__VITE_ASSET__0fb7add9__"